module.exports = __webpack_public_path__ + "static/media/anleitung.b75bd7f8.png";